import { reloadChunksAction } from '../controls';
import { reconnectReload } from './AppStatusProvider';
import { buildSettingValueChoices, showSettingReloadModal, } from './SettingReloadModal';
export const applySettingReloadResult = (result) => {
    if (result.reloadMode === 'chunks') {
        reloadChunksAction();
    }
    else if (result.reloadMode === 'page') {
        reconnectReload();
    }
};
export const promptAndApplyReloadSetting = async (args) => {
    const result = await showSettingReloadModal({
        ...args,
        valueChoices: buildSettingValueChoices(args.currentValue, args.possibleValues),
    });
    return result;
};
